// extracted by mini-css-extract-plugin
export default {"mobileOnly":"vJYOe","desktopOnly":"QkQ9x"};